module.exports = __webpack_public_path__ + "static/media/11.bdc17eb8.jpg";